import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss']
})
export class EventDetailsComponent implements OnInit {
  events: any = [];
  event: any = {};
  eventId: any = '';
  recentEvents: any = [];
  cate: any = [];
  categories: any = {};
  categoryList: any = [];
  siteUrl = environment.siteUrl;
  constructor(private appService: AppService, private activeRoute: ActivatedRoute) {
    this.activeRoute.params.subscribe((res: any) => {
      this.eventId = res.eventId;
      this.getEventInfo();
    })
  }

  ngOnInit() {
    this.appService.getEvents().subscribe((res: any) => {
      this.events = res;
      this.recentEvents = JSON.parse(JSON.stringify(res)).splice(0, 4);
      this.events.forEach((item: any) => {
        if (!this.categories[item.category]) {
          this.categories[item.category] = 1;
        } else {
          this.categories[item.category] += 1;
        }
      });
      this.categoryList = Object.keys(this.categories);
    })
  }

  getEventInfo() {
    this.appService.getEventDetails(this.eventId).subscribe((res: any) => {
      this.event = res;
    })
  }
}
